import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  kebab: function kebab(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      text-align: center;\n      border: ", ";\n      box-sizing: border-box;\n      border-radius: ", ";\n      user-select: none;\n      cursor: pointer;\n      outline: 0;\n      transition: background 0.12s ease-out;\n      width: 26px;\n      height: 26px;\n      background: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n    "])), t.kebabBorder, t.kebabBorderRadius, t.kebabBackground, t.kebabBackgroundHover);
  },
  focused: function focused(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      border-color: ", ";\n    "])), t.kebabBackgroundHover, t.borderColorFocus);
  },
  opened: function opened(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      background: ", " !important; // override kebab:hover style\n      cursor: default;\n    "])), t.kebabBackgroundHover);
  },
  disabled: function disabled() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      cursor: default;\n\n      &:hover {\n        background: none;\n      }\n    "])));
  },
  icon: function icon() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      color: #757575;\n    "])));
  },
  iconsmall: function iconsmall() {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      margin-top: 1px;\n      margin-left: 0.8124px;\n      font-size: 14px;\n    "])));
  },
  iconmedium: function iconmedium() {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      margin-top: -2px;\n      margin-left: 0.5px;\n      font-size: 18px;\n    "])));
  },
  iconlarge: function iconlarge() {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      margin-top: -4px;\n      margin-left: 0.5px;\n      font-size: 20px;\n      display: inline-block;\n      vertical-align: -2px;\n    "])));
  },
  menu: function menu(t) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      overflow: hidden;\n      border-radius: ", ";\n    "])), t.popupBorderRadius);
  }
});